import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Modal, Input, message, Select, Cascader, Upload } from 'antd';
import { useUpdateEffect } from 'ahooks';
import { queryEditContentInfo, updateEditContentInfo, queryCaseInfo, styleList, classifyList, desingerList } from "../../api";
import AliUploader from '../../component/AliUploader/linggan_aliupload';
// 富文本编辑器引入插件库以及样式----------------
import BraftEditor from 'braft-editor';
import { ContentUtils } from 'braft-utils'
import 'braft-editor/dist/index.css';
import "./index.less";
import { UploadToOss } from '../../util/uploadTool';
const { Option } = Select;
// 富文本插入图片所需常量
const dirname = 'caseManage/'
const imgPrefix =
    'https://qingtu-image-originals.oss-cn-shanghai.aliyuncs.com/'
const token = {
    host: 'https://image.znzgo.com/',
    ALI_HOST: imgPrefix,
    // access_key_id: 'LTAI5t8ubGymdJDnqyAe2EM2', // oss的key_id
    // access_key_secret: 'zfkvIN3eft7FrYJqfCRDURjGxhSHcF', // oss的secret
    OSS_ENDPOINT: 'oss-cn-shanghai.aliyuncs.com', // 自己oss服务器的配置信息
    OSS_BUCKET: 'qingtu-image-originals', // 自己oss服务器的配置信息
    OSS_REGION: 'oss-cn-shanghai',
}
const loseImgUrl = 'http://dingzi-jsfile.oss-cn-shanghai.aliyuncs.com/%E8%A3%82%E5%9B%BE/%E8%A3%82%E5%9B%BE.png'//默认显示的无图状态图片地址
// const caseLevelList = ['一级', '二级', '三级']
const caseLevel = [
    {
        id: 1,
        levelName: '一级',
    },
    {
        id: 2,
        levelName: '二级',
    },
    {
        id: 3,
        levelName: '三级',
    },
    {
        id: 4,
        levelName: '四级',
    },
    {
        id: 5,
        levelName: '五级',
    },
    {
        id: 6,
        levelName: '六级',
    },
]
const reg = /^\d+(\.\d+)?$/;
const Editor = () => {
    const [caseId, setCaseId] = useState('')
    const [caseTitle, setCaseTitle] = useState('')//当前标题内容
    const [caseImgUrl, setCaseImgUrl] = useState('')
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [isCheck, setIscheck] = useState(false)//弹窗显示确定查询还是确定重置条件

    // case2.0.3需求所需变量
    // 等级选择所需变量
    const [levelValue, setLevelValue] = useState('')
    // 编辑详情国家列表接口数据
    const [countryValue, setCountryValue] = useState('')
    const [nationCountryList, setNationCountryList] = useState([])//编辑后获取国家列表数据

    // 分类所需变量
    const [options, setOptions] = useState([])// 分类处理后的数据数组
    const [chooseClassifyIdArr, setChooseClassifyIdArr] = useState([])
    const [cascaderValue, setCascaderValue] = useState([])
    const [allClassifyList, setAllClassifyList] = useState([])
    const [chooseListId, setChooseListId] = useState([])
    const [classifyIdList, setClassifyIdList] = useState([])
    const [editorClassifyList, setEditorClassifyList] = useState([])
    const [editorClassifyId, setEditorClassifyId] = useState([])
    const [showChooseList, setShowChooseList] = useState([])
    // 风格数据所需变量
    const [styleListData, setStyleListData] = useState([])
    const [styleValue, setStyleValue] = useState([])//选中的风格数组id
    const [editorStyleList, setEditorStyleList] = useState([])//编辑后获取已有的风格列表
    const [editorStyleIdList, setEditorStyleIdList] = useState([])//编辑后获取已有的风格列表
    const [styleIdList, setStyleIdList] = useState([])//最终提交的风格数组id
    const [showChooseStyleList, setShowChooseStyleList] = useState([])
    //  设计师数据所需变量
    const [desingerListData, setDesingerListData] = useState([])
    const [desingerValue, setDesingerValue] = useState()
    const [editorDesingerIdList, setEditorDesingerIdList] = useState([])//最终提交设计师id数组
    const [editorDesingerList, setEditorDesingerList] = useState([])//编辑获取已有的设计师列表
    const [chooseDesingerIdList, setChooseDesingerIdList] = useState([])//最终提交后选择的设计师id数组
    const [showChooseDesingerList, setShowChooseDesingerList] = useState([])//选中的设计师展示列表

    //默认展示的文本以及图片内容
    const [initCoverImg, setInitCoverImg] = useState(loseImgUrl)//默认封面图url
    // const [country, setCountry] = useState('无')//默认国家内容
    // const [initLevel, setInitLevel] = useState('无')//默认等级内容
    // const [initStyle, setInitStyle] = useState('无')//默认风格内容
    // const [initClassify, setInitClassify] = useState('无')//默认分类内容
    const [searchCaseData, setSearchCaseData] = useState(null)//查询ID后保存的案例数据
    // 设置编辑器初始内容
    const [editorState, setEditorState] = useState(BraftEditor.createEditorState(''));//默认插入img展示的话必须带有div标签 否则无法编辑切记
    // 第一次查询渲染后富文本的内容保存
    const [firstEditorCnt, setFirstEditorCnt] = useState('');
    // 拿到history
    const history = useHistory()

    // 实时查看已选分类的id数组集合
    useEffect(() => {
        console.log('chooseListId======', chooseListId)
    }, [chooseListId])
    useEffect(() => {
        console.log('editorClassifyId======', editorClassifyId)
    }, [editorClassifyId])
    useEffect(() => {
        getFirstClassifyList()
        getStyleList()
        getDesingerList()
    }, [])
    useEffect(() => {
        history.listen(historyLocation => {
            if (historyLocation.pathname != '/case/editor') {
                setShowConfirmModal(true)
            } else {
            }
        })
    }, [history])
    // 搜索案例后 触发左侧的分类更新
    useEffect(() => {
        console.log('editorClassifyList', editorClassifyList)
        if (editorClassifyList.length > 0) {
            let classifyIdList = [];
            editorClassifyList.forEach(item => {
                classifyIdList.push(item.id)
            })
            // setClassifyIdList(classifyIdList)
            setEditorClassifyId(classifyIdList)
        }
    }, [editorClassifyList])
    // // 选中分类展示的id添加到最终提交id数组中(带一二级分类名称以及二级分类id)
    useEffect(() => {
        if (showChooseList.length > 0) {
            let addId = []
            showChooseList.forEach(item => {
                addId.push(item.id)
            })
            setChooseListId(addId)
            // 新增后添加已有二级分类的id组合最终提交的二级分类id数组集合
            // setClassifyIdList(addId.concat(editorClassifyId))
        }
    }, [showChooseList])


    // // 监听已经有风格更新
    useEffect(() => {
        console.log(editorStyleList)
        if (editorStyleList.length > 0) {
            let editorStyleIdList = [];
            editorStyleList.forEach(item => {
                editorStyleIdList.push(item.styleId)
            })
            setEditorStyleIdList(editorStyleIdList)
        } else {
            setEditorStyleIdList([])
        }
    }, [editorStyleList])
    // 监听已有设计师列表更新
    useEffect(() => {
        if (editorDesingerList.length > 0) {
            let editorDesingerIdList = [];
            editorDesingerList.forEach(item => {
                editorDesingerIdList.push(item.propertyId)
            })
            // console.log('最终确定修改提交的参数数组是', classifyIdList)
            setEditorDesingerIdList(editorDesingerIdList)
        } else {
            setEditorDesingerIdList([])
        }
    }, [editorDesingerList])

    let uploadFileType = useRef(0)
    let uploadButtonType = useRef(0)
    // 暂存数据
    let isUploadInit = useRef({
        introductionUpload: false,
        installUpload: false,
        useTutorialUpload: false,
    })
    // let uploaderInit = useRef(() => { })
    // 监听当输入上传图片地址为空的时候默认显示无图状态
    useEffect(() => {
        if (caseImgUrl == '') {
            setInitCoverImg(loseImgUrl)
        }
    }, [caseImgUrl])
    // 监听查询后的数据显示和用户是否操作修改内容

    // 查詢接口初始化调取方法
    const getCaseSearchData = () => {
        setShowChooseList([])
        setCascaderValue([])
        setChooseClassifyIdArr([])
        setShowChooseStyleList([])//弹窗关闭清空用户已添加的风格显示数组
        setStyleValue([])//弹窗关闭清空用户已选择的风格id数组（未点击添加）
        setStyleIdList([])//弹窗关闭清空用户已选择的风格最终提交id数组（已添加）
        setLevelValue([])//清空等级
        queryEditContentInfo(caseId).then(res => {
            if (res?.error?.errorCode == 0) {
                console.log(res?.data)
                handleCaseCoverImg(res?.data?.cases)//处理案例封面图显示内容方式
                handleCaseTitle(res?.data?.cases)//处理当前案例标题显示内容方式
                setLevelValue(res?.data?.caseLevel ? res?.data?.caseLevel?.caseLevel : '')//回归等级下拉框显示没有就为空
                setNationCountryList(res?.data?.nationCountryList)//国家列表展示
                setCountryValue(res?.data?.cases?.country)//默认显示哪个国家
                setEditorClassifyList(res?.data?.caseClassifyDTOList)
                setEditorStyleList(res?.data?.caseStyleContents ? res?.data?.caseStyleContents : [])
                // handleCaseLevel(res?.data?.caseLevel)//处理案例等级显示内容方式
                // handleCaseStyleContents(res?.data?.caseStyleContents)//处理风格显示内容方式
                // handleCaseClassifyDTOList(res?.data?.caseClassifyDTOList)//处理分类显示内容方式
                // setCountry(res?.data?.cases.country)
                handleCaseContentList(res?.data?.caseContentList)//处理正文显示内容
                setSearchCaseData(res?.data)//赋值查询id原有数据
                let designMasterVoList = (res?.data?.designMasterVoList != null) ? res?.data?.designMasterVoList : []
                setEditorDesingerList(designMasterVoList)
            } else {
                message.error(res?.error?.errorMsg)

            }
        })
    }
    // 查询id
    const checkCaseId = () => {
        if (caseId == '') {
            message.info('案例ID不能为空!')
        } else {
            if (!reg.test(caseId)) {
                message.info('请输入案例数字ID')
            } else {
                if (searchCaseData) {
                    // 当前已查询过再次查询处理
                    if (handleChangePageCnt()) {//内容被更改过但未点确定修改
                        setIscheck(true)
                        setShowConfirmModal(true)
                    } else {
                        getCaseSearchData()
                    }
                } else {
                    getCaseSearchData()
                }
            }


        }
    }

    // 处理当前封面图显示方法
    const handleCaseCoverImg = (cases) => {
        if (cases) {
            if (cases.cover) {
                setInitCoverImg(cases.cover)
            } else {
                setInitCoverImg(initCoverImg)
            }

        } else {
            setInitCoverImg(initCoverImg)
        }
    }
    // 处理当前标题显示方法
    const handleCaseTitle = (cases) => {
        if (cases) {
            setCaseTitle(cases.titleOrigin)
        } else {
            setCaseTitle('')
        }
    }
    // 处理等级显示方法
    // const handleCaseLevel = (caseLevel) => {
    //     if (caseLevel) {
    //         if (caseLevel.caseLevel) {
    //             setInitLevel(caseLevelList[caseLevel.caseLevel - 1])
    //         } else {
    //             setInitLevel('无')
    //         }
    //     } else {
    //         setInitLevel('无')
    //     }
    // }
    // 处理风格内容显示方法
    // const handleCaseStyleContents = (caseStyleContents) => {
    //     let showCnt = '';
    //     if (caseStyleContents.length > 0) {
    //         caseStyleContents.forEach(item => {
    //             showCnt += item.styleValue + '，'
    //         });
    //         setInitStyle(showCnt.slice(0, showCnt.length - 1))
    //     } else {
    //         setInitStyle('无')
    //     }

    // }
    // 处理分类显示内容方式
    // const handleCaseClassifyDTOList = (caseClassifyDTOList) => {
    //     let showCnt = '';
    //     if (caseClassifyDTOList.length > 0) {
    //         caseClassifyDTOList.forEach(item => {
    //             showCnt += (item.rootName ? item.rootName : '') + (item.rootName ? '-' : '') + (item.parentName ? item.parentName : '') + (item.parentName ? '-' : '') + (item.name ? item.name : '') + '，'
    //         });
    //         setInitClassify(showCnt.slice(0, showCnt.length - 1))
    //     } else {
    //         setInitClassify('无')
    //     }

    // }

    // 处理富文本默认显示内容
    const handleCaseContentList = (caseContentList) => {
        let showEditorCnt = '';
        let saveFirstCnt = ""
        if (caseContentList.length > 0) {
            caseContentList.forEach(item => {
                if (item.textOriginCss && item.textOriginCss != '') {
                    if (item.textOriginCss.indexOf("img") != -1) {
                        showEditorCnt += '<div>' + item.textOriginCss.replaceAll('class="media-wrap image-wrap"', "") + '</div>'
                    } else {
                        showEditorCnt += item.textOriginCss
                    }
                    saveFirstCnt += item.textOriginCss
                } else {
                    if (item.type == 0) {
                        showEditorCnt += '<div><img src="' + item.imgUrl + '"/></div>'
                        saveFirstCnt += '<img src="' + item.imgUrl + '"/>'
                    } else {
                        showEditorCnt += '<p>' + item.textOrigin + '</p>'
                        saveFirstCnt += '<p>' + item.textOrigin + '</p>'
                    }
                }
            })
            // console.log(showEditorCnt)
            setFirstEditorCnt(saveFirstCnt)//存储第一次渲染后富文本默认内容（字符串）
            setEditorState(BraftEditor.createEditorState(showEditorCnt))
        } else {
            setEditorState(BraftEditor.createEditorState(''))
        }
    }

    // 当第二次点击查询的时候调用验证用于是否修改了标题 封面图以及富文本内容 true为已更改
    const handleChangePageCnt = () => {
        if (searchCaseData) {
            if (searchCaseData.cases) {
                if ((searchCaseData.cases.titleOrigin != caseTitle) || (searchCaseData.cases.cover != initCoverImg) || (firstEditorCnt != getNewEditorCnt())) {
                    // console.log(searchCaseData.cases.titleOrigin)
                    // console.log(caseTitle)
                    // console.log(searchCaseData.cases.cover)
                    // console.log(initCoverImg)
                    // console.log(firstEditorCnt)
                    // console.log(getNewEditorCnt())
                    // console.log('我修改了内容！')
                    localStorage.setItem('isChanged', '1')
                    return true;
                } else {
                    localStorage.setItem('isChanged', '0')
                    return false
                }
            }
        }
    }
    // 重置搜索
    const resetCase = () => {
        if (searchCaseData) {
            // 当前已查询过再次查询处理
            if (handleChangePageCnt()) {//内容被更改过但未点确定修改
                setIscheck(false)//弹窗为 ‘确认重置’字符
                setShowConfirmModal(true)
            } else {
                // 内容未被修改过重置清空当前内容
                resetAllCnt()
            }
        } else {
            resetAllCnt()
        }

    }

    // 点击上传 上传图片地址 保存到本地
    const uploadCaseImg = () => {
        if (caseImgUrl == '') {
            message.info('请输入需要上传的图片地址！')
        } else {
            setInitCoverImg(caseImgUrl)
        }

    }
    // 编辑内容触发
    const handleChange = (editorState) => {
        setEditorState(editorState)
        console.log(editorState)
    }

    // 确定修改获取编辑器内容以及提交所修改内容
    const gettEditorCnt = (type) => {
        console.log(type)
        const content = editorState.toHTML().replaceAll("<p></p>", "").replaceAll("<div></div>", "").replaceAll('<div class="media-wrap image-wrap">', "<p>").replaceAll('</div>', "</p>")
        console.log(content)//获取编辑后的内容处理后的字符串
        if (caseTitle == '') {
            message.info('标题不能为空！')
            return
        }
        if (initCoverImg != loseImgUrl && initCoverImg == '') {
            message.info('封面图地址不能为空！')
            return
        }
        if (caseId == '') {
            message.info('案例ID不能为空！')
            return
        }
        if (content == '') {
            message.info('正文内容不能为空！')
            return
        }
        // console.log('最终提交的风格数组id是', styleIdList.concat(editorStyleIdList))
        // console.log('最终提交的风格数组id是', chooseListId.concat(editorClassifyId))
        let params = {
            caseLevel: levelValue ? levelValue : '',
            caseStyleIdList: styleIdList.concat(editorStyleIdList),
            classifyIdList: chooseListId.concat(editorClassifyId),
            designMasterPropertyList: editorDesingerIdList.concat(chooseDesingerIdList),
            cases: {
                caseId: caseId,
                cover: initCoverImg,
                titleOrigin: caseTitle,
                country: countryValue ? countryValue : ''
            },
            html: content,
            type: type
        }
        updateEditContentInfo(params).then(res => {
            // console.log(res)
            if (res?.error?.errorCode == 0) {
                message.success('修改成功！')
                setChooseListId([])
                setEditorClassifyId([])
                setChooseDesingerIdList([])
                setShowChooseDesingerList([])
                setEditorDesingerIdList([])
                setEditorDesingerList([])
                setDesingerValue('')
                getCaseSearchData()
            } else {
                message.info(res?.error?.errorMsg)
            }

        })


    }
    // return 当富文本内容变化的时候执行返回一次富文本内文本字符串
    const getNewEditorCnt = () => {
        return editorState.toHTML().replaceAll("<p></p>", "").replaceAll("<div></div>", "").replaceAll('<div class="media-wrap image-wrap">', "").replaceAll('</div>', "")
            .replaceAll('<p class="media-wrap image-wrap align-center"></p>', "")
        // return editorState.toHTML().replaceAll("<div>", "<p>").replaceAll("</div>", "</p>").replaceAll("<div", "<p").replaceAll("<div></div>", "")
    }
    // 弹窗 确认查询或重置 触发事件
    const confirmReset = () => {
        if (isCheck) {
            // 确认查询

            getCaseSearchData()
        } else {
            // 确认重置
            resetAllCnt()
        }
        cancelModal()
    }
    // 全部置空页面内容
    const resetAllCnt = () => {
        setSearchCaseData({})
        setCaseId('')
        setCaseTitle('')
        // setInitLevel('无')
        // setCountry('无')
        // setInitStyle('无')
        // setInitClassify('无')
        setCaseImgUrl('')
        setInitCoverImg(loseImgUrl)//默认封面图
        setEditorState(BraftEditor.createEditorState(''))
        setShowChooseList([])
        setCascaderValue([])
        setChooseClassifyIdArr([])
        setEditorStyleList([])
        setEditorClassifyList([])
        setShowChooseStyleList([])//弹窗关闭清空用户已添加的风格显示数组
        setStyleValue([])//弹窗关闭清空用户已选择的风格id数组（未点击添加）
        setStyleIdList([])//弹窗关闭清空用户已选择的风格最终提交id数组（已添加）
        setLevelValue([])//清空等级
        setCountryValue('')//重置国家下拉框选中
        setChooseDesingerIdList([])
        setShowChooseDesingerList([])
        setEditorDesingerIdList([])
        setEditorDesingerList([])
        setDesingerValue('')
        message.info('已重置！')
    }
    // 关闭弹窗
    const cancelModal = () => {
        setShowConfirmModal(false)
    }
    // 其他按钮的上传功能上传功能
    // mediaType: 0 - 插入图片
    // mediaType: 1 - 插入
    // buttonType 0 - 软件介绍、1 - 安装教程、2 - 使用教程
    const otherUpload = (info, uploaded_object_name) => {
        // console.log(info)
        if (info.status == 200) {
            // 采用token.host 作为cdn地址这样比oss流量便宜
            const url = `${token.host}${uploaded_object_name}`
            // console.log(url);
            // const { getFieldValue, setFieldsValue } = this.props.form;
            let result = null;
            result = ContentUtils.insertMedias(editorState, [{
                type: 'IMAGE',
                url,
            }]);
            setEditorState(result);
            message.success('上传成功！')
        } else {
            message.error('上传失败！')
        }
    }

    // 等级选择
    const handleChangelevel = value => {
        setLevelValue(value);
    };
    // 国家选择
    const handleChangeCountry = (value) => {
        // console.log('我选择的国家是', value)
        setCountryValue(value)
    }
    // ---------------分类所需方法--------------------
    // 获取分类下拉框数据
    const getFirstClassifyList = () => {
        classifyList()
            .then((res) => {
                if (res?.error?.errorCode == 0) {
                    setAllClassifyList(res?.data)
                    handleClassifyList(res?.data)
                }
            })
    }
    //  处理级联选择器内部数据格式
    const handleClassifyList = (classifyList) => {
        let arr = []
        classifyList.forEach(item => {
            let obj = {
                value: '',
                label: '',
                children: [

                ],
            }
            obj.value = item.id;
            obj.label = item.name;
            item.secondClassifies.forEach((childItem, index) => {
                obj.children.push({
                    value: childItem.id,
                    label: childItem.name,
                    children: []
                })
                childItem.thirdClassifies.forEach(thirdItem => {
                    obj.children[index].children.push({
                        value: thirdItem.id,
                        label: thirdItem.name
                    })
                });
            })
            arr.push(obj)
        });
        // console.log(arr)
        setOptions(arr)
    }
    //  处理添加后的分类名称显示
    const handleClassifyNameList = (arr) => {
        // console.log(arr)
        if (arr[0].length > 0) {
            let moreShowChooseList = [];
            arr.forEach(item => {
                let obj = {
                    firstName: '',
                    secondName: '',
                    thirdName: '',
                    id: ''
                }
                let filterFirstArr = allClassifyList.filter(tem => tem.id == item[0])
                obj.firstName = filterFirstArr[0].name;
                if (item.length > 1) {
                    let filterSecondArr = filterFirstArr[0].secondClassifies.filter(tem => tem.id == item[1])
                    obj.secondName = filterSecondArr[0].name;
                }
                if (item.length > 2) {
                    let filterSecondArr = filterFirstArr[0].secondClassifies.filter(tem => tem.id == item[1])
                    obj.secondName = filterSecondArr[0].name;
                    let filterThridArr = filterSecondArr[0].thirdClassifies.filter(tem => tem.id == item[2])
                    obj.thirdName = filterThridArr[0].name;
                }
                obj.id = item[item.length - 1];
                moreShowChooseList.push(obj);
            })
            // console.log(moreShowChooseList)
            setShowChooseList(moreShowChooseList)
        }

    }
    // 级联选择器选中时间
    const onChange = (value) => {
        setCascaderValue(value)
    }
    // 点击添加 增加分类到下方框中
    const addChoose = () => {
        // console.log(cascaderValue)

        if (cascaderValue.length > 0) {
            let arr = chooseClassifyIdArr;
            // 去重
            if (chooseListId.includes(cascaderValue[cascaderValue.length - 1]) || editorClassifyId.includes(cascaderValue[cascaderValue.length - 1])) {
                message.error('您已添加该分类')
            } else {
                arr.push(cascaderValue)
                setChooseClassifyIdArr(arr);
                handleClassifyNameList(arr);
            }
        } else {
            message.error('请选择分类')
        }

    }
    // 点击X删除默认编辑栏的分类
    const deleteEditorIndex = (index) => {
        let arr = [...editorClassifyList]
        let list2 = editorClassifyId.filter(item => item != arr[index].id)
        // console.log(list2)
        setEditorClassifyId(list2)

        // 删除视图显示
        arr.splice(index, 1);
        setEditorClassifyList(arr)
    }
    // 点击X删除对应新增的分类
    const deleteIndex = (index) => {
        let arr1 = [...showChooseList]
        let arr2 = [...chooseClassifyIdArr]
        // 删除对应的classifyId
        let list = chooseListId.filter(item => item != arr1[index].id)
        setChooseListId(list)
        arr1.splice(index, 1);
        arr2.splice(index, 1);
        setShowChooseList(arr1)
        setChooseClassifyIdArr(arr2)
    }


    // ---------------风格所需方法--------------------
    // 获取风格下拉框数据
    const getStyleList = () => {
        styleList()
            .then((res) => {
                if (res?.error?.errorCode == 0) {
                    setStyleListData(res?.data)
                }
            })
    }

    // 风格多选change获取id数组
    const handleChangeStyleVal = (value) => {
        setStyleValue(value)
    }
    //  点击添加 增加风格到下方框中
    const addStyle = () => {
        if (styleValue.length > 0) {
            let arr = [...styleIdList];
            let hasIdArr = styleValue.filter(item => styleIdList.concat(editorStyleIdList).indexOf(item) > -1)
            // console.log(hasIdArr)

            // 去重
            if (hasIdArr.length > 0) {
                message.error('您已添加某个风格')
            } else {
                arr = arr.concat(styleValue)
                // console.log(arr)
                // console.log(editorStyleIdList)
                setStyleIdList(arr)
                handleStyleNameList(arr);
            }
        } else {
            message.error('请选择风格')
        }
    }
    //  处理添加后的风格名称显示
    const handleStyleNameList = (arr) => {
        if (arr.length > 0) {
            let showChooseStyleList = [];
            showChooseStyleList = styleListData.filter(item => arr.indexOf(item.id) > -1)
            setShowChooseStyleList(showChooseStyleList)
        }

    }
    //  处理添加后的设计师名称显示
    const handleDesingerNameList = (arr) => {
        if (arr.length > 0) {
            let newArr = [...showChooseDesingerList];
            newArr = desingerListData.filter(item => arr.indexOf(item.propertyId) > -1)
            console.log(newArr)
            setShowChooseDesingerList(newArr)
        }

    }
    // 点击X删除编辑栏已存在的风格列表
    const deleteEditorStyleIndex = (deleteId) => {
        let list1 = editorStyleIdList.filter(item => item != deleteId)
        let list2 = editorStyleList.filter(item => item.styleId != deleteId)

        setEditorStyleIdList(list1)
        setEditorStyleList(list2)
    }
    // 点击X删除对应新增的风格
    const deleteStyleIndex = (deleteId) => {
        // 删除对应的classifyId
        let list1 = styleIdList.filter(item => item != deleteId)
        // console.log(list1)
        let list2 = showChooseStyleList.filter(item => item.id != deleteId)
        setStyleIdList(list1)
        setShowChooseStyleList(list2)
    }

    //  设计师所需方法---------------------
    // 获取设计师下拉框数据
    const getDesingerList = () => {
        desingerList()
            .then((res) => {
                if (res?.error?.errorCode == 0) {
                    setDesingerListData(res?.data)
                }
            })
    }
    // 设计师选择选择
    const handleChangeDesinger = (value) => {
        console.log('我选择的设计师是', value)
        setDesingerValue(value)
    }
    //  点击添加 增加设计师到下方框中
    const addDesinger = () => {
        if (desingerValue) {
            //  添加手动选择的设计师ID到数组中
            let arr = [...chooseDesingerIdList]
            let hasIdArr = showChooseDesingerList.concat(editorDesingerList).filter(item => item.propertyId == desingerValue)
            // 去重
            if (hasIdArr.length > 0) {
                message.error('您已添加该设计师')
            } else {
                //存入手动选择的id
                arr.push(desingerValue)
                setChooseDesingerIdList(arr)
                handleDesingerNameList(arr)
            }
        }
    }
    // 点击X删除编辑栏已存在的设计师
    const deleteEditorDesingerIndex = (deleteId) => {
        let list1 = editorDesingerIdList.filter(item => item != deleteId)
        let list2 = editorDesingerList.filter(item => item.propertyId != deleteId)
        setEditorDesingerIdList(list1)
        setEditorDesingerList(list2)
    }

    // 点击X删除对应新增的设计师
    const deleteChooseDesingerIndex = (deleteId) => {
        let list1 = chooseDesingerIdList.filter(item => item != deleteId)
        let list2 = showChooseDesingerList.filter(item => item.propertyId != deleteId)
        setChooseDesingerIdList(list1)
        setShowChooseDesingerList(list2)
    }

    const beforeUpload = (file, index) => {
        const img_type = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
        const img_size = file.size / 1024 / 1024;
        if (!img_type.includes(file.type)) {
            return false;
        }
        if (img_size > 50) {
            return false;
        }

        let reader = new FileReader();
        reader.readAsDataURL(file);
        const OssToken = token;
        reader.onloadend = async () => {
            // 使用ossupload覆盖默认的上传方法
            message.loading('上传中');
            UploadToOss({ token: OssToken }, OssToken.ALI_HOST, file)
                .then((data) => {
                    let url = OssToken.host + '/' + data.name;
                    // console.log(url);
                    // const { getFieldValue, setFieldsValue } = this.props.form;
                    let result = null;
                    result = ContentUtils.insertMedias(editorState, [{
                        type: 'IMAGE',
                        url,
                    }]);
                    setEditorState(result);
                    console.debug('data', data)
                    message.success('上传成功！')
                })
                .catch((err) => {
                    message.destroy();
                    message.error('上传失败，请重试~');
                })
                .finally(() => {
                    message.destroy();
                });
        };

        return false;
    };
    return (
        <>
            <h2>案例正文编辑</h2>
            <div className='form_item topItem'>
                <span className='form_item_label'>案例ID：</span>
                <Input className='form_item_input' placeholder="请输入案例ID" value={caseId} onChange={e => setCaseId(e.target.value)} />
                <Button type='primary' className='form_item_button' onClick={checkCaseId}>查询</Button>
                <Button type='primary' className='form_item_button' onClick={resetCase}>重置</Button>
            </div>
            <div className='editorBox'>
                <div className='leftEditorCnt'>
                    <div className='editorDetailBox_top'>
                        <div className='coverCnt'>
                            <div className='coverImg'>
                                <img src={initCoverImg} alt="" />
                            </div>
                            <div className='form_item rightCnt'>
                                <p>封面图地址：</p>
                                <Input className='upload_input' placeholder="" value={caseImgUrl} onChange={e => setCaseImgUrl(e.target.value)} />
                                <div className='uploadBtn'>
                                    <Button type='primary' className='form_item_button' onClick={uploadCaseImg}>上传</Button>
                                </div>
                                <div className='form_item title'>
                                    <span className='form_item_label'>等级&nbsp;&nbsp;：</span>
                                    <Select value={levelValue} style={{ width: 165 }} onChange={handleChangelevel}>
                                        {
                                            caseLevel.length > 0 ? caseLevel.map((item, index) => {
                                                return (
                                                    <Option value={item.id} key={index}>{item.levelName}</Option>
                                                )
                                            }) : ''
                                        }
                                    </Select>
                                </div>
                                <div className='form_item'>
                                    <span className='form_item_label'>国家&nbsp;&nbsp;：</span>
                                    <Select showSearch="true"
                                        allowClear
                                        optionFilterProp="children" value={countryValue} style={{ width: 165 }} onChange={handleChangeCountry}
                                    >
                                        {
                                            nationCountryList.length > 0 ? nationCountryList.map((item, index) => {
                                                return (
                                                    <Option value={item.name} key={index}>{item.name}</Option>
                                                )
                                            }) : ''
                                        }
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div className='form_item'>
                            <span className='form_item_label'>标题：</span>
                            <Input className='title_input' placeholder="" value={caseTitle} onChange={e => setCaseTitle(e.target.value)} />
                        </div>

                        {/* 分类 */}
                        <div className='form_item'>
                            <span className='form_item_label'>分类：</span>
                            <Cascader
                                value={cascaderValue}
                                options={options}
                                placeholder="请选择分类"
                                expandTrigger="hover"
                                onChange={onChange}
                            />
                            <span className='addBtnStyle' onClick={addChoose}>添加</span>
                        </div>
                        <div className='classifyInput'>
                            <ul>
                                {
                                    editorClassifyList.length > 0 ? editorClassifyList.map((item, index) => {
                                        return (
                                            <li key={index}>
                                                <span>{item.rootName ? item.rootName : ''}</span>
                                                <span>{item.rootName ? '-' : ''}</span>
                                                <span>{item.parentName ? item.parentName : ''}</span>
                                                <span>{item.parentName ? '-' : ''}</span>
                                                <span>{item.name ? item.name : ''}</span>
                                                <span onClick={() => deleteEditorIndex(index)}>X</span>
                                            </li>
                                        )
                                    }) : ''
                                }
                                {
                                    showChooseList.length > 0 ? showChooseList.map((item, index) => {
                                        return (
                                            <li key={index}>
                                                <span>{item.firstName}</span>
                                                <span>{item.secondName != '' ? '-' : ''}</span>
                                                <span>{item.secondName}</span>
                                                <span>{item.thirdName != '' ? '-' : ''}</span>
                                                <span>{item.thirdName}</span>
                                                <span onClick={() => deleteIndex(index)}>X</span>
                                            </li>
                                        )
                                    }) : ''
                                }

                            </ul>
                        </div>
                        {/* 风格 */}
                        <div className='form_item'>
                            <span className='form_item_label'>风格：</span>
                            <Select
                                mode="multiple"
                                value={styleValue}
                                allowClear
                                style={{ width: 231 }}
                                placeholder="请选择风格"
                                onChange={handleChangeStyleVal}
                            >
                                {
                                    styleListData.length > 0 ? styleListData.map((item, index) => {
                                        return (
                                            <Option value={item.id} key={index} label={item.styleValue}>{item.styleValue}</Option>
                                        )
                                    }) : ''
                                }
                            </Select>
                            <span className='addBtnStyle' onClick={addStyle}>添加</span>
                        </div>
                        <div className='classifyInput'>
                            <ul>
                                {

                                    editorStyleList.length > 0 ? editorStyleList.map((item, index) => {
                                        return (
                                            <li key={index}>
                                                <span>{item.styleValue}</span>
                                                <span onClick={() => deleteEditorStyleIndex(item.styleId)}>X</span>
                                            </li>
                                        )
                                    }) : ''
                                }
                                {
                                    showChooseStyleList.length > 0 ? showChooseStyleList.map((item, index) => {
                                        return (
                                            <li key={index}>
                                                <span>{item.styleValue}</span>
                                                <span onClick={() => deleteStyleIndex(item.id)}>X</span>
                                            </li>
                                        )
                                    }) : ''
                                }

                            </ul>
                        </div>

                        <div className='form_item'>
                            <span className='form_item_label'>设计师：</span>
                            <Select
                                showSearch='true'
                                allowClear
                                placeholder="请选择或输入关键词查询设计师"
                                optionFilterProp="children" value={desingerValue} style={{ width: 231 }} onChange={handleChangeDesinger}
                            >
                                {
                                    desingerListData.length > 0 ? desingerListData.map((item, index) => {
                                        return (
                                            <Option value={item.propertyId} key={index}>{item.name}</Option>
                                        )
                                    }) : ''
                                }
                            </Select>
                            <span className='addBtnStyle' onClick={addDesinger}>添加</span>
                        </div>
                        <div className='classifyInput'>
                            <ul>
                                {

                                    editorDesingerList.length > 0 ? editorDesingerList.map((item, index) => {
                                        return (
                                            <li key={index}>
                                                <span>{item.name}</span>
                                                <span onClick={() => deleteEditorDesingerIndex(item.propertyId)}>X</span>
                                            </li>
                                        )
                                    }) : ''
                                }
                                {
                                    showChooseDesingerList.length > 0 ? showChooseDesingerList.map((item, index) => {
                                        return (
                                            <li key={index}>
                                                <span>{item.name}</span>
                                                <span onClick={() => deleteChooseDesingerIndex(item.propertyId)}>X</span>
                                            </li>
                                        )
                                    }) : ''
                                }

                            </ul>
                        </div>
                    </div>

                    {/* <div className='editorDetailBox_bottom'>
                        <div className='editorDetail'>
                            <span className='form_item_label'>国家：</span>
                            <p>{country ? country : '无'}</p>
                        </div>
                        <div className='editorDetail'>
                            <span className='form_item_label'>等级：</span>
                            <p>{initLevel}</p>
                        </div>
                        <div className='editorDetail'>
                            <span className='form_item_label'>风格：</span>
                            <p>{initStyle}</p>
                        </div>
                        <div className='editorDetail'>
                            <span className='form_item_label'>分类：</span>
                            <p>{initClassify}</p>
                        </div>
                    </div> */}

                </div>
                <BraftEditor
                    contentStyle={{ height: 700 }}
                    value={editorState}
                    // disabled={!this.state.isEdit}
                    // controls={[//默认配置
                    //     'undo', 'redo', 'separator',
                    //     'font-size', 'line-height', 'letter-spacing', 'separator',
                    //     'text-color', 'bold', 'italic', 'underline', 'strike-through', 'separator',
                    //     'superscript', 'subscript', 'remove-styles', 'emoji', 'separator', 'text-indent', 'text-align', 'separator',
                    //     'headings', 'list-ul', 'list-ol', 'blockquote', 'code', 'separator',
                    //     'link', 'separator', 'hr', 'separator', 'separator', 'clear'
                    // ]}
                    controls={[//需求所需要的的配置
                        'undo', 'redo', 'separator',
                        'font-size', 'line-height', 'letter-spacing', 'separator',
                        'text-color', 'bold', 'italic', 'underline', 'strike-through', 'separator',
                        'separator', 'text-indent', 'text-align', 'separator',
                        'separator', 'separator', 'clear'
                    ]}
                    placeholder="请输入正文内容"
                    onChange={handleChange}
                    extendControls={[
                        {
                            key: 'useTutorialImage_upload',
                            type: 'component',
                            component: (
                                <div style={{ paddingTop: '12px', cursor: 'pointer' }}>
                                    <Upload
                                        // {...props}
                                        showUploadList={false}
                                        beforeUpload={(file) => beforeUpload(file, index)}
                                    >
                                        <div
                                            onClick={() => {
                                                uploadFileType.current = 0
                                                uploadButtonType.current = 1
                                            }}
                                        >
                                            {/* 这里的按钮最好加上type="button"，以避免在表单容器中触发表单提交，用Antd的Button组件则无需如此 */}
                                            <button
                                                id="useTutorialImage_upload"
                                                type="button"
                                                className="control-item button upload-button"
                                                data-title="仅支持jpg,jpeg,png,gif格式"
                                            >
                                                插入图片
                                            </button>
                                        </div>
                                    </Upload>
                                </div>
                            )
                        },
                    ]}
                    onFocus={() => {
                        const { useTutorialUpload } = isUploadInit.current;
                        if (!useTutorialUpload) {
                            isUploadInit.current.useTutorialUpload = true;
                            // uploaderInit.current(); // 初始化上传功能
                            console.log("功能初始化")
                        }
                    }}
                />

            </div>
            {/* <AliUploader
                id="useTutorialImage_upload"
                dirname={dirname}
                fileUploaded={(up, file, info, uploaded_object_name) => {
                    console.log(uploaded_object_name)
                    // otherUpload(info, `${imgPrefix}/${uploaded_object_name}`)
                    otherUpload(info, uploaded_object_name)
                }}
                uploaderInit={(func) => (uploaderInit.current = func)}
                token={token}
            /> */}
            <div className='saveCnt'>
                <Button type='primary' onClick={() => gettEditorCnt(1)}>确认修改</Button>
                <Button type='primary' onClick={() => gettEditorCnt(0)}>修改并同步审核</Button>
            </div>
            <Modal width='400px' height='120px' maskClosable={false} visible={showConfirmModal} wrapClassName='tip_modal' onCancel={cancelModal} footer={null}>
                <p>当前修改内容未成功修改!</p>
                <div>
                    <Button type='primary' className='modal_button' onClick={confirmReset}>{isCheck ? '确认查询' : '确认重置'}</Button>
                    <Button className='modal_button' onClick={cancelModal}>取消</Button>
                </div>
            </Modal>
        </>
    )
}
export default Editor;